export function getTranslationValue(
  translations: Record<string, string>,
  localeKey: string,
  defaultValue = '',
): string {
  return translations[localeKey] ?? defaultValue;
}
